// extracted by mini-css-extract-plugin
export default {"modal-link":"_2L0ey","modalLink":"_2L0ey"};